import template from './aliAuth.template.html';

export default {
  bindings: {
    email: '<',
    onFinish: '&'
  },
  controller: class controller {
    constructor($mdDialog, $rootScope) {
      'ngInject';

      const ctrl = this;
      ctrl.$mdDialog = $mdDialog;

      ctrl.initialize = () => {
        $mdDialog
          .show({
            locals: {},
            template,
            controllerAs: '$ctrl',
            controller() {
              const self = this;
              self.brokerId = '';
              self.brokerEmail = ctrl.email || $rootScope.CurrentAccount.user.eMail;
              self.isEdit = false;

              self.confirm = () => {
                $mdDialog.hide({ brokerId: self.brokerId, brokerEmail: self.brokerEmail });
              };
              self.cancel = () => {
                $mdDialog.hide(false);
              };
            },
            multiple: true,
            clickOutsideToClose: false
          })
          .then((res) => {
            ctrl.onFinish({ status: res });
          });
      };

      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
